<form #f="ngForm" (ngSubmit)="f.form.valid && onConfirmRegisterOTP()" appFocusFirstElement>
  <h2 mat-dialog-title>{{'title.input_code_otp' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <div class="form-group row mt-3">
      <div class="col-12">
        <mat-form-field class="w-100">
          <input (focusout)="confirmOtp.otp = confirmOtp.otp.trim()" matInput
            [placeholder]="'form.code_confirm' | translate" type="text" name="otp" id="otp" [(ngModel)]="confirmOtp.otp"
            #otp="ngModel" maxlength="6" required />
          <button mat-button *ngIf="confirmOtp.otp" type="button" matSuffix mat-icon-button aria-label="Clear"
            (click)="confirmOtp.otp=''">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="f.submitted || otp.invalid">
            <span *ngIf="otp.invalid || otp?.errors?.validInput">
              {{ 'validation.confirm_code_is_number' | translate }}
            </span>
          </mat-error>
        </mat-form-field>
        <small class="form-text">{{'form.code_confirm_send_to_phone_register' | translate}}</small>
      </div>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-stroked-button color="primary" class="mr-3" (click)="onSendCodeOTPAgain()" type="button">
      <mat-icon class="mr-0">send</mat-icon>
      {{'button.send_code_otp_again' | translate}}
    </button>
    <button mat-raised-button type="submit" [disabled]="!f.form.valid" color="primary">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.confirm' | translate}}
    </button>
  </mat-dialog-actions>
</form>
